import common from './common-educabot'

export default {
  ...common.button,
  color: `#2A205E`,
  bg: `#ffffff`,
  '::before': {
    display: `none`
  },
  '::after': {
    ...common.button['::after'],
    bg: `#ffffff`,
    border: 'none',
  },
  '&:hover': {
    color: '#9e3006'
    },
}